export default "__VITE_ASSET__BMih9U_T__"